import EcoFee from './ecoFee.component';

export default EcoFee;
